var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.0 18.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trash_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "trash_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,4 L13,16 C13,17.1 12.1,18 11,18 L3,18 C1.9,18 1,17.1 1,16 L1,4 L13,4 Z M9.5,0 L10.5,1 L14,1 L14,3 L0,3 L0,1 L3.5,1 L4.5,0 L9.5,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-233.0 -624.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trash_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.9999999999986 621.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.0 3.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trash_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 14,0 14,18 0,18 0,0",
    stroke: "none"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.72769cfe51da3411dc4d6ce2002c9e23.svg";
export { ForwardRef as ReactComponent };